import React from 'react';
import { motion } from 'framer-motion';
export function EbookMockup() {
  return <section className="bg-gradient-to-b from-wellness-white to-wellness-light-sage py-24 px-6 overflow-hidden" data-id="element-22">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative w-full max-w-lg mx-auto" data-id="element-24">
          {/* Floating Badge */}
          <motion.div initial={{
          scale: 0,
          rotate: -10
        }} whileInView={{
          scale: 1,
          rotate: 12
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} className="absolute -top-6 -right-6 md:-right-12 z-20 bg-wellness-gold text-white font-bold py-3 px-6 rounded-full shadow-xl shadow-wellness-gold/30 border-4 border-white transform rotate-12" data-id="element-25">
            PDF Descargable
          </motion.div>

          {/* Tablet Frame Mockup */}
          <div className="relative bg-gray-900 rounded-[2.5rem] p-4 shadow-2xl shadow-wellness-dark/20 transform md:rotate-[-2deg] hover:rotate-0 transition-transform duration-500 ease-out" data-id="element-26">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-xl z-10" data-id="element-27" />{' '}
            {/* Notch */}
            <div className="relative rounded-[1.5rem] overflow-hidden bg-white aspect-[3/4] border border-gray-800" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/wMkfvm4BuJr2KRSfQMmcJi/CONCEPTO_4.png" alt="Ebook Preview" className="w-full h-full object-cover object-top" data-id="element-29" />
              {/* Subtle glare effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 pointer-events-none" data-id="element-30" />
            </div>
          </div>

          {/* Decorative background blur */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-wellness-sage/20 rounded-full blur-3xl -z-10" data-id="element-31" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-12 space-y-2" data-id="element-32">
          <p className="text-xl font-medium text-wellness-dark" data-id="element-33">
            Acceso inmediato después del pago
          </p>
          <p className="text-wellness-dark/60 text-sm" data-id="element-34">
            Compatible con cualquier dispositivo (teléfono, tablet o
            computadora)
          </p>
        </motion.div>
      </div>
    </section>;
}